module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gF4TE"))).then(() => module.bundle.root('3a9aZ'));